// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"d8aac071ec98f94ce4e7","224":"9b1f223341e8dd116357"}[chunkId] + ".css";
};